import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import {
  ALL_EMAIL_ROLE_LIST_URL,
  ALL_PROJECT_LIST_URL,
  APPLICATION_CHAT_LIST_URL,
  DASHBOARD_ACTIVITY_LIST_URL,
  DASHBOARD_TODO_LIST_DUE_DATE_URL,
  FORM_BUILDER_FOLDER_LIST_URL,
  FORM_BUILDER_FORM_COLLABORATOR_URL,
  FORM_BUILDER_FORM_COVER_IMAGE_URl,
  FORM_BUILDER_FORM_INSTRUCTION_URL,
  FORM_BUILDER_FORM_LIST_URL,
  GET_EMAIL_TEMPLATE_CATEGORY_LIST_URL,
  GET_EMAIL_TEMPLATE_LIST_URL,
  GET_EMAIL_WORKFLOW_LIST_URL,
  GLOBAL_QUESTION_LIST_URL,
  LIST_COLUMN_URL,
  PROJECT_ACTION_LIST_URL,
  PROJECT_APPLICATION_STAGE_URL,
  PROJECT_FILTER_LIST_URL,
  SPECIFIC_APPLICANT_DETAILS,
  GET_USER_LIST_URL,
  GET_STAGE_LIST_URL,
  GET_ADMIN_ACTION_LIST_URL,
  GET_ADMIN_FIELD_LIST_URL,
  GET_ADMIN_ROLE_LIST_URL,
  GET_PROJECT_ATTRIBUTE_LIST_URL,
  GET_USER_MENU_LIST_URL,
  GET_USER_TYPE_LIST_URL,
  FORM_BUILDER_FORM_DETAILS_APPLICATION_URL,
  GET_ACCOUNT_SETTING_MENU_LIST_URL,
  STUDENT_APPLICATIONS__URL,
  getOfferLetterListByCategoryUrl,
  deleteUserProfileUrl,
  getGlobalLanguageListUrl,
  getGlobalDataListUrl,
  getJobsPopularCategoryUrl,
  getJobsTestimonialUrl,
  getAdminGroupListUrl,
  getGlobalSkillsUrl,
  getOrgListUrl,
  getRulesTenantListUrl,
  getRulesTriggerListUrl,
  getRulesActionTypeListUrl,
  getRulesActionValueSourceListUrl,
} from "./api";
import { translate } from "../i18n";
import { authService, newAuthService, unAuthService } from "../Service/Axios";

// Global
export const useUserList = (autoFetch = true) => {
  const [userList, setUserList] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchUserList = async () => {
    try {
      setLoading(true);
      const response = await newAuthService(GET_USER_LIST_URL, "POST", {});
      if (response.status) {
        setUserList(response.data);
      } else {
        setUserList();
      }
    } catch (error) {
      toast.error("Error fetching user list:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (autoFetch) {
      fetchUserList();
    }
  }, [autoFetch]);

  return { loading, userList, fetchUserList };
};

export const useUserTypeList = () => {
  const [userTypeList, setUserTypeList] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchUserTypeList = async () => {
    try {
      const response = await newAuthService(GET_USER_TYPE_LIST_URL, "POST", {});
      if (response.status) {
        setUserTypeList(response.data);
      } else {
        setUserTypeList([]);
      }
    } catch (error) {
      toast.error("Error fetching userType list:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUserTypeList();
  }, []);

  return { userTypeList, loading, fetchUserTypeList };
};

export const useProjectList = () => {
  const [projectList, setProjectList] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchProjectList = async () => {
    try {
      const response = await newAuthService(ALL_PROJECT_LIST_URL, "POST", {});
      if (response.status) {
        setProjectList(response.data);
      } else {
        setProjectList([]);
      }
    } catch (error) {
      toast.error("Error fetching project list:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProjectList();
  }, []);

  return { projectList, loading };
};

export const useQuestionList = () => {
  const [questionList, setQuestionList] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchQuestionList = async () => {
    try {
      const response = await newAuthService(
        GLOBAL_QUESTION_LIST_URL,
        "POST",
        {}
      );
      if (response.status) {
        setQuestionList(response.data);
      } else {
        setQuestionList([]);
      }
    } catch (error) {
      toast.error("Error fetching question list:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchQuestionList();
  }, []);

  return { questionList, loading };
};

export const useOfferLetterList = () => {
  const [offerLetterList, setOfferLetterList] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchOfferLetterList = async () => {
    try {
      const payload = { type: "1" };
      const response = await newAuthService(
        getOfferLetterListByCategoryUrl,
        "POST",
        payload
      );
      if (response.status) {
        setOfferLetterList(response.data);
      } else {
        setOfferLetterList([]);
      }
    } catch (error) {
      toast.error("Error fetching offerLetter list:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOfferLetterList();
  }, []);

  return { offerLetterList, loading };
};

// Menus
export const useMenuList = () => {
  const [menuList, setMenuList] = useState([]);
  const [orginalMenuList, setOrginalMenuList] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchMenuList = async () => {
    try {
      const response = await newAuthService(GET_USER_MENU_LIST_URL, "POST", {});
      if (
        response.status &&
        response.data.success &&
        response.data.data &&
        response.data.data.length > 0
      ) {
        setMenuList(response.data.data.map((res) => res.gid));
        setOrginalMenuList(response.data.data);
      } else {
        setMenuList([]);
        setOrginalMenuList([]);
      }
    } catch (error) {
      toast.error("Error fetching menu list:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMenuList();
  }, []);

  return { menuList, orginalMenuList, loading, fetchMenuList };
};

export const useAccountSettingMenuList = () => {
  const [accountSettingMenuList, setAccountSettingMenuList] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchAccountSettingMenuList = async () => {
    try {
      const response = await newAuthService(
        GET_ACCOUNT_SETTING_MENU_LIST_URL,
        "POST",
        {}
      );
      if (
        response.status &&
        response.data &&
        response.data.data &&
        response.data.data.length > 0
      ) {
        setAccountSettingMenuList(response.data.data.map((res) => res.gid));
      } else {
        setAccountSettingMenuList([]);
      }
    } catch (error) {
      toast.error("Error fetching menu list:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAccountSettingMenuList();
  }, []);

  return { accountSettingMenuList, loading, fetchAccountSettingMenuList };
};

// Admin Dashboard
export const useTodoList = (dueDate) => {
  const [todoList, setTodoList] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchTodoList = async () => {
    try {
      const payload = dueDate ? { dueDate } : {};
      const response = await newAuthService(
        DASHBOARD_TODO_LIST_DUE_DATE_URL,
        "POST",
        payload
      );
      if (response.status) {
        setTodoList(response.data);
      } else {
        setTodoList([]);
      }
    } catch (error) {
      toast.error("Error fetching todo list:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTodoList();
  }, [dueDate]);

  return { todoList, loading, fetchTodoList };
};

export const useActivityList = () => {
  const [activityList, setActivityList] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchActivityList = async () => {
      try {
        const response = await newAuthService(
          DASHBOARD_ACTIVITY_LIST_URL,
          "POST",
          {}
        );
        if (response.status) {
          setActivityList(response.data);
        } else {
          setActivityList([]);
        }
      } catch (error) {
        toast.error("Error fetching activity list:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchActivityList();
  }, []);

  return { activityList, loading };
};

export const useColumnList = (projectId) => {
  const [columnList, setColumnList] = useState([]);
  const [duplicateColumnList, setDuplicateColumnList] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchColumnList = async () => {
      try {
        const payload = {
          gid: projectId,
          projectType: "dashboard",
        };
        const response = await newAuthService(LIST_COLUMN_URL, "POST", payload);
        if (response.status) {
          setColumnList(response.data.fieldsetting);
          setDuplicateColumnList(response.data.fieldsetting);
        } else {
          setColumnList([]);
          setDuplicateColumnList([]);
        }
      } catch (error) {
        toast.error("Error fetching column list:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchColumnList();
  }, [projectId]);

  return { columnList, setColumnList, duplicateColumnList, loading };
};

export const useFilterList = (projectId) => {
  const [filterList, setFilterList] = useState([]);
  const [duplicateFilterList, setDuplicateFilterList] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchFilterList = async () => {
      try {
        const payload = {
          projectType: "dashboard",
        };
        if (projectId) {
          payload.gid = projectId;
        }
        const response = await newAuthService(
          PROJECT_FILTER_LIST_URL,
          "POST",
          payload
        );
        if (response.status) {
          setFilterList(response.data.filters);
          setDuplicateFilterList(response.data.filters);
        } else {
          setFilterList([]);
          setDuplicateFilterList([]);
        }
      } catch (error) {
        toast.error("Error fetching filter list:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchFilterList();
  }, [projectId]);

  return {
    filterList,
    setFilterList,
    duplicateFilterList,
    loading,
  };
};

export const useProjectActionList = (projectId, currentStage) => {
  const [projectActionList, setProjectActionList] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchProjectActionList = async (pId, sId) => {
    try {
      const payload = {
        projectId: pId,
        projectType: "dashboard",
        stage: sId,
      };
      const response = await newAuthService(
        PROJECT_ACTION_LIST_URL,
        "POST",
        payload
      );
      if (response.status) {
        setProjectActionList(response.data);
      } else {
        setProjectActionList([]);
      }
    } catch (error) {
      toast.error("Error fetching projectAction list:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (currentStage) {
      fetchProjectActionList(projectId, currentStage);
    }
  }, [projectId, currentStage]);

  return { projectActionList, loading, fetchProjectActionList };
};

export const useApplicationStage = (projectId) => {
  const [applicationStage, setApplicationStage] = useState([]);
  const [applicationStageSlider, setApplicationStageSlider] = useState([]);
  const [applicationStageDropdown, setApplicationStageDropdown] = useState([]);
  const [defaultStageId, setDefaultStageId] = useState("");
  const [projectName, setProjectName] = useState("");
  const [loading, setLoading] = useState(true);

  const fetchApplicationStage = async () => {
    try {
      const payload = {
        gid: projectId,
        projectType: "dashboard",
      };
      const response = await authService(
        PROJECT_APPLICATION_STAGE_URL,
        "POST",
        payload
      );
      if (response) {
        const { applicationStage } = response;
        const allStageId =
          applicationStage &&
          applicationStage.length > 0 &&
          applicationStage[0].stageId;
        setDefaultStageId(allStageId);
        setApplicationStage(applicationStage);
        if (applicationStage.length > 6) {
          setApplicationStageSlider(applicationStage.slice(0, 6));
          const restApplicationStage = applicationStage
            .slice(6, applicationStage.length)
            .map((stage) => ({
              value: stage.stageId,
              label: stage.name,
              count: stage.number,
            }));
          setApplicationStageDropdown(restApplicationStage);
        } else {
          setApplicationStageSlider(applicationStage);
          setApplicationStageDropdown([]);
        }
        setProjectName(response.name);
        return applicationStage;
      }
    } catch (error) {
      toast.error("Error fetching projectAction list:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchApplicationStage();
  }, [projectId]);

  return {
    projectName,
    applicationStage,
    applicationStageSlider,
    applicationStageDropdown,
    defaultStageId,
    loading,
    fetchApplicationStage,
  };
};

// Form Builder
export const useFolderList = () => {
  const [folderList, setFolderList] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchFolderList = async () => {
    try {
      const response = await newAuthService(
        FORM_BUILDER_FOLDER_LIST_URL,
        "POST",
        {}
      );
      if (response.status) {
        setFolderList(response.data);
      } else {
        setFolderList([]);
      }
    } catch (error) {
      toast.error("Error fetching folder list:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFolderList();
  }, []);

  return { folderList, loading, fetchFolderList };
};

export const useFormList = (payload) => {
  const [formList, setFormList] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchFormList = async () => {
    setLoading(true);
    try {
      const response = await newAuthService(
        FORM_BUILDER_FORM_LIST_URL,
        "POST",
        payload
      );
      if (response.status) {
        setFormList(response.data);
      } else {
        setFormList([]);
      }
    } catch (error) {
      toast.error("Error fetching form list:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (
      payload.archive ||
      payload.favorite ||
      payload.folderId ||
      payload.recyleBin ||
      payload.template
    ) {
      fetchFormList();
    }
  }, [payload]);

  return { formList, setFormList, fetchFormList, loading };
};

export const useFormCoverImageList = (folderId) => {
  const [coverImageList, setCoverImageList] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchCoverImageList = async () => {
    try {
      const response = await newAuthService(
        FORM_BUILDER_FORM_COVER_IMAGE_URl,
        "POST",
        {}
      );
      if (response.status) {
        setCoverImageList(response.data);
      } else {
        setCoverImageList([]);
      }
    } catch (error) {
      toast.error("Error fetching coverImage list:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCoverImageList();
  }, [folderId]);

  return { coverImageList, setCoverImageList, loading };
};

export const useFormCollaboratorList = (formId) => {
  const [formCollaboratorList, setFormCollaboratorList] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchFormCollaboratorList = async () => {
    try {
      const payload = {
        formId,
      };
      const response = await newAuthService(
        FORM_BUILDER_FORM_COLLABORATOR_URL,
        "POST",
        payload
      );
      if (response.status) {
        setFormCollaboratorList(response.data);
      } else {
        setFormCollaboratorList([]);
      }
    } catch (error) {
      toast.error("Error fetching formCollaborator list:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFormCollaboratorList();
  }, [formId]);

  return { formCollaboratorList, setFormCollaboratorList, loading };
};

export const useFormDetails = (formId, search) => {
  const [formDetails, setFormDetails] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchFormDetails = async () => {
    try {
      const payload = {
        formId,
      };
      if (search) {
        payload.urlParameter = search;
      }
      const response = await newAuthService(
        FORM_BUILDER_FORM_DETAILS_APPLICATION_URL,
        "POST",
        payload
      );
      if (response.status) {
        setFormDetails(response.data);
      } else {
        setFormDetails([]);
      }
    } catch (error) {
      toast.error("Error fetching formDetails:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFormDetails();
  }, [formId]);

  return { formDetails, setFormDetails, loading };
};

export const useFormInstruction = (formId, urlParameter) => {
  const [formInstruction, setFormInstruction] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchFormInstruction = async () => {
    try {
      const payload = {
        formId,
        urlParameter,
      };
      const response = await unAuthService(
        FORM_BUILDER_FORM_INSTRUCTION_URL,
        "POST",
        payload
      );
      setFormInstruction(response);
    } catch (error) {
      toast.error("Error fetching formInstruction:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFormInstruction();
  }, [formId]);

  return { formInstruction, loading };
};

// Applicant
export const useApplicantDetails = (gid) => {
  const [applicantDetails, setApplicantDetails] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchApplicantDetails = async () => {
    try {
      const payload = {
        gid,
      };
      const response = await newAuthService(
        SPECIFIC_APPLICANT_DETAILS,
        "POST",
        payload
      );
      if (response.status) {
        setApplicantDetails(response.data);
      } else {
        setApplicantDetails(null);
      }
    } catch (error) {
      toast.error("Error fetching applicantDetails:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchApplicantDetails();
  }, [gid]);

  return { applicantDetails, loading };
};

export const useApplicantProjectList = (gid) => {
  const [applicantProjectList, setApplicantProjectList] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchApplicantProjectList = async () => {
    try {
      const payload = {};
      if (gid) {
        payload.userId = gid;
      }
      const response = await newAuthService(
        STUDENT_APPLICATIONS__URL,
        "POST",
        payload
      );
      if (response.status) {
        setApplicantProjectList(response.data);
      } else {
        setApplicantProjectList([]);
      }
    } catch (error) {
      toast.error("Error fetching applicantProjectList:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchApplicantProjectList();
  }, []);

  return { applicantProjectList, loading };
};

export const useChatList = (gid) => {
  const [chatList, setChatList] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchChatList = async () => {
    try {
      const payload = {
        gid,
      };
      const response = await newAuthService(
        APPLICATION_CHAT_LIST_URL,
        "POST",
        payload
      );
      if (response.status) {
        setChatList(response.data);
      } else {
        setChatList([]);
      }
    } catch (error) {
      toast.error("Error fetching chatList:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchChatList();
  }, [gid]);

  return { chatList, setChatList, fetchChatList, loading };
};

// Email Template
export const useEmailTemplateList = () => {
  const [allEmailTemplateList, setAllEmailTemplateList] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchAllEmailTemplateList = async () => {
    try {
      const response = await newAuthService(
        GET_EMAIL_TEMPLATE_LIST_URL,
        "POST",
        {}
      );
      if (response.status) {
        setAllEmailTemplateList(response.data);
      } else {
        setAllEmailTemplateList([]);
      }
    } catch (error) {
      toast.error("Error fetching allEmailTemplate list:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAllEmailTemplateList();
  }, []);

  return { allEmailTemplateList, loading };
};

export const useEmailTemplateCategoryList = () => {
  const [categoryList, setCategoryList] = useState([]);
  const [activeCategory, setActiveCategory] = useState("");
  const [loading, setLoading] = useState(true);

  const fetchCategoryList = async () => {
    try {
      const response = await newAuthService(
        GET_EMAIL_TEMPLATE_CATEGORY_LIST_URL,
        "POST",
        {}
      );
      if (response.status) {
        setCategoryList(response.data);
        setActiveCategory(response.data && response.data[0].category);
      } else {
        setCategoryList([]);
        setActiveCategory("");
      }
    } catch (error) {
      toast.error("Error fetching category list:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCategoryList();
  }, []);

  return {
    categoryList,
    activeCategory,
    setActiveCategory,
    fetchCategoryList,
    loading,
  };
};

// Email Settings
export const useEmailWorkflowList = () => {
  const [allEmailWorkflowList, setAllEmailWorkflowList] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchAllEmailWorkflowList = async () => {
    try {
      const response = await newAuthService(
        GET_EMAIL_WORKFLOW_LIST_URL,
        "POST",
        {}
      );
      if (response.status) {
        setAllEmailWorkflowList(response.data);
      } else {
        setAllEmailWorkflowList([]);
      }
    } catch (error) {
      toast.error("Error fetching allEmailWorkflow list:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAllEmailWorkflowList();
  }, []);

  return { allEmailWorkflowList, fetchAllEmailWorkflowList, loading };
};

export const useEmailRoleList = () => {
  const [emailRoleList, setEmailRoleList] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchEmailRoleList = async () => {
    try {
      const response = await authService(ALL_EMAIL_ROLE_LIST_URL, "POST", {});
      setEmailRoleList(response);
    } catch (error) {
      toast.error("Error fetching emailRole list:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchEmailRoleList();
  }, []);

  return { emailRoleList, loading };
};

// Admin Settings
export const useStageList = () => {
  const [stageList, setStageList] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchStageList = async () => {
    try {
      const response = await authService(GET_STAGE_LIST_URL, "POST", {});
      setStageList(response);
    } catch (error) {
      toast.error("Error fetching stage list:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchStageList();
  }, []);

  return { stageList, loading, fetchStageList };
};

export const useActionList = () => {
  const [actionList, setActionList] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchActionList = async () => {
    try {
      const response = await authService(GET_ADMIN_ACTION_LIST_URL, "POST", {});
      setActionList(response);
    } catch (error) {
      toast.error("Error fetching action list:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchActionList();
  }, []);

  return { actionList, loading, fetchActionList };
};

export const useFieldList = () => {
  const [fieldList, setFieldList] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchFieldList = async () => {
    try {
      const response = await authService(GET_ADMIN_FIELD_LIST_URL, "POST", {});
      setFieldList(response);
    } catch (error) {
      toast.error("Error fetching field list:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFieldList();
  }, []);

  return { fieldList, loading, fetchFieldList };
};

export const useAttributeList = () => {
  const [attributeList, setAttributeList] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchAttributeList = async () => {
    try {
      const response = await authService(
        GET_PROJECT_ATTRIBUTE_LIST_URL,
        "POST",
        {}
      );
      setAttributeList(response);
    } catch (error) {
      toast.error("Error fetching attribute list:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAttributeList();
  }, []);

  return { attributeList, loading, fetchAttributeList };
};

export const useRoleList = (autoFetch = true) => {
  const [roleList, setRoleList] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchRoleList = async () => {
    try {
      setLoading(true);
      const response = await newAuthService(
        GET_ADMIN_ROLE_LIST_URL,
        "POST",
        {}
      );
      if (response.status) {
        setRoleList(response.data);
      } else {
        setRoleList([]);
      }
    } catch (error) {
      toast.error("Error fetching role list:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (autoFetch) {
      fetchRoleList();
    }
  }, [autoFetch]);

  return { roleList, loading, fetchRoleList };
};

export const useGroupList = (autoFetch = true) => {
  const [groupList, setGroupList] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchGroupList = async () => {
    try {
      setLoading(true);
      const response = await newAuthService(getAdminGroupListUrl, "POST", {});
      if (response.status) {
        setGroupList(response.data);
      } else {
        setGroupList([]);
      }
    } catch (error) {
      toast.error("Error fetching group list:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (autoFetch) {
      fetchGroupList();
    }
  }, [autoFetch]);

  return { groupList, loading, fetchGroupList };
};

export const useDeleteUserProfileSectionItem = () => {
  const [loading, setLoading] = useState(true);

  const deleteUserProfileSectionItem = async (payload) => {
    setLoading(true);
    const response = await newAuthService(
      deleteUserProfileUrl,
      "POST",
      payload
    );
    if (response.status) {
      toast.success(
        translate(
          "common.messages.notification.success.deleteProfileSectionItem",
          {
            key: translate(`auth.viewProfile.${payload.key}`),
          }
        )
      );
    } else {
      toast.error(
        translate("common.messages.notification.failed.somethingWentWrong")
      );
    }
  };

  return { loading, deleteUserProfileSectionItem };
};

export const useLanguageList = () => {
  const [languageList, setLanguageList] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchLanguageList = async () => {
    try {
      const response = await authService(getGlobalLanguageListUrl, "POST", {});
      setLanguageList(response);
    } catch (error) {
      toast.error("Error fetching language list:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLanguageList();
  }, []);

  return { languageList, loading, fetchLanguageList };
};

export const useGlobalDataList = () => {
  const [globalDataList, setGlobalDataList] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchGlobalDataList = async () => {
    try {
      const response = await newAuthService(getGlobalDataListUrl, "POST", {});
      if (response.status) {
        setGlobalDataList(response.data);
      } else {
        setGlobalDataList([]);
      }
    } catch (error) {
      toast.error("Error fetching globalData list:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchGlobalDataList();
  }, []);

  return { globalDataList, loading, fetchGlobalDataList };
};

export const useGlobalSkillsList = () => {
  const [globalSkillsList, setGlobalSkillsList] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchGlobalSkillsList = async () => {
    try {
      const response = await newAuthService(getGlobalSkillsUrl, "POST", {});
      if (response.status) {
        setGlobalSkillsList(response.data);
      } else {
        setGlobalSkillsList([]);
      }
    } catch (error) {
      toast.error("Error fetching globalSkills list:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchGlobalSkillsList();
  }, []);

  return { globalSkillsList, loading, fetchGlobalSkillsList };
};

export const useJobsPopularCategoryList = () => {
  const [jobsPopularCategoryList, setJobsPopularCategoryList] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchJobsPopularCategoryList = async () => {
    try {
      const response = await unAuthService(
        getJobsPopularCategoryUrl,
        "POST",
        {}
      );
      if (response) {
        setJobsPopularCategoryList(response);
      } else {
        setJobsPopularCategoryList([]);
      }
    } catch (error) {
      toast.error("Error fetching jobsPopularCategory list:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchJobsPopularCategoryList();
  }, []);

  return { jobsPopularCategoryList, loading, fetchJobsPopularCategoryList };
};

export const useJobsTestimonialList = () => {
  const [jobsTestimonialList, setJobsTestimonialList] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchJobsTestimonialList = async () => {
    try {
      const response = await unAuthService(getJobsTestimonialUrl, "POST", {});
      if (response) {
        setJobsTestimonialList(response);
      } else {
        setJobsTestimonialList([]);
      }
    } catch (error) {
      toast.error("Error fetching jobsTestimonial list:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchJobsTestimonialList();
  }, []);

  return { jobsTestimonialList, loading, fetchJobsTestimonialList };
};

export const useOrganizationList = () => {
  const [organizationList, setOrganizationList] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchOrganizationList = async () => {
    try {
      const response = await newAuthService(getOrgListUrl, "POST", {});
      if (response.status) {
        setOrganizationList(response.data);
      } else {
        setOrganizationList([]);
      }
    } catch (error) {
      toast.error("Error fetching organization list:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOrganizationList();
  }, []);

  return { organizationList, loading, fetchOrganizationList };
};

export const useRulesTenantList = () => {
  const [rulesTenantList, setRulesTenantList] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchRulesTenantList = async () => {
    try {
      const response = await newAuthService(getRulesTenantListUrl, "POST", {});
      if (response.status) {
        setRulesTenantList(response.data);
      } else {
        setRulesTenantList([]);
      }
    } catch (error) {
      toast.error("Error fetching rulesTenant list:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRulesTenantList();
  }, []);

  return { rulesTenantList, loading, fetchRulesTenantList };
};

export const useRulesTriggerList = () => {
  const [rulesTriggerList, setRulesTriggerList] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchRulesTriggerList = async () => {
    try {
      const response = await newAuthService(getRulesTriggerListUrl, "POST", {});
      if (response.status) {
        setRulesTriggerList(response.data);
      } else {
        setRulesTriggerList([]);
      }
    } catch (error) {
      toast.error("Error fetching rulesTrigger list:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRulesTriggerList();
  }, []);

  return { rulesTriggerList, loading, fetchRulesTriggerList };
};

export const useRulesActionTypeList = () => {
  const [rulesActionTypeList, setRulesActionTypeList] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchRulesActionTypeList = async () => {
    try {
      const response = await newAuthService(
        getRulesActionTypeListUrl,
        "POST",
        {}
      );
      if (response.status) {
        setRulesActionTypeList(response.data);
      } else {
        setRulesActionTypeList([]);
      }
    } catch (error) {
      toast.error("Error fetching rulesActionType list:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRulesActionTypeList();
  }, []);

  return { rulesActionTypeList, loading, fetchRulesActionTypeList };
};

export const useRulesActionValueSourceList = () => {
  const [rulesActionValueSourceList, setRulesActionValueSourceList] = useState(
    []
  );
  const [loading, setLoading] = useState(true);

  const fetchRulesActionValueSourceList = async () => {
    try {
      const response = await newAuthService(
        getRulesActionValueSourceListUrl,
        "POST",
        {}
      );
      if (response.status) {
        setRulesActionValueSourceList(response.data);
      } else {
        setRulesActionValueSourceList([]);
      }
    } catch (error) {
      toast.error("Error fetching rulesActionValueSource list:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRulesActionValueSourceList();
  }, []);

  return {
    rulesActionValueSourceList,
    loading,
    fetchRulesActionValueSourceList,
  };
};
